import { MILKvKeys, useGetKeyPairValue } from 'api/microlearning/useAPIKeyValue'
import {
  filterAvailableWebinars,
  getUserEmailFromSession,
} from 'app/PelatihanMandiriPage/utils/webinar'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

import type { WebinarEntry } from 'api/microlearning/types'

type WebinarEntriesValue = {
  webinar?: WebinarEntry[]
}

export const getWebinarTabLabel = (count?: number) =>
  typeof count === 'number' ? `Webinar (${count})` : 'Webinar'

export const useWebinarTabCount = (enabled = true) => {
  const { data, status } = useGetKeyPairValue<WebinarEntriesValue>(
    MILKvKeys.WebinarEntries,
    enabled
  )
  const userSession = useLocalStorage('app-login', undefined)
  const userEmail = getUserEmailFromSession(userSession)

  if (!enabled || status !== 'success') return undefined

  return filterAvailableWebinars(data?.data?.webinar ?? [], userEmail).length
}
